import React from 'react';
import { NewModal } from 'lib/components';
import { Flex, Gap } from 'lib/components/styles/layout';
import { Button, Typography } from 'react-covideo-common';
import { useDeletePronunciationMutation } from 'lib/api/pronunciations/useDeletePronunciationMutation';
import { IPronunciation } from 'lib/api/pronunciations/useQueryPronunciations';

interface DeletePronunciationModalProps {
  pronunciation: IPronunciation;
  onClose: () => void;
}

export const DeletePronunciationModal = ({
  pronunciation,
  onClose,
}: DeletePronunciationModalProps) => {
  const { mutateAsync: deletePronunciationMutation, isLoading: isDeleting } =
    useDeletePronunciationMutation(onClose);

  const onDelete = () => {
    deletePronunciationMutation({ id: pronunciation.id });
  };

  return (
    <NewModal
      headerText='Delete Pronunciation'
      closeModal={onClose}
      style={{
        content: { width: 592, maxWidth: 592 },
      }}
    >
      <Flex flexDirection='column' gap='20px'>
        <Typography>
          Are you sure you want to delete the "{pronunciation.text}"
          pronunciation?
        </Typography>
        <Gap gap='8px' justifyContent='flex-end'>
          <Button
            text='Cancel'
            onClick={onClose}
            variant='secondary'
            disabled={isDeleting}
          />
          <Button
            text='Delete'
            onClick={onDelete}
            variant='destructive'
            loading={isDeleting}
            disabled={isDeleting}
          />
        </Gap>
      </Flex>
    </NewModal>
  );
};
